<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="twitter-alt-circle_12107562 1">
<path id="Vector" d="M5.71777 5.63257L13.1144 15.3034H14.2478L6.93527 5.63257H5.71777Z" fill="black"/>
<path id="Vector_2" d="M10 0.5C4.4775 0.5 0 4.9775 0 10.5C0 16.0225 4.4775 20.5 10 20.5C15.5225 20.5 20 16.0225 20 10.5C20 4.9775 15.5225 0.5 10 0.5ZM12.5525 16.5267L9.3275 12.3142L5.6425 16.5267H3.59417L8.37167 11.065L3.33333 4.47333H7.55167L10.4633 8.32417L13.8325 4.47333H15.8783L11.4108 9.57833L16.6667 16.5258L12.5525 16.5267Z" fill="black"/>
</g>
</svg>
